import { clsx, type ClassValue } from "clsx";

import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(inputDateTime: string) {
  const date = new Date(inputDateTime);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
}

export function formatCurrency(value: number | string) {
  const number =
    typeof value === "string"
      ? Number(value.replace(/\s/g, "").replace(/kr/i, ""))
      : value;

  if (isNaN(Number(number))) return value;

  const formatted = new Intl.NumberFormat("no-NO", {
    style: "decimal",
    useGrouping: true,
    minimumFractionDigits: 0,
  }).format(number);

  return `kr ${formatted}`;
}

export const phoneNumberValidations: Record<string, (num: string) => boolean> =
  {
    "+47": (num) => num.length === 8,
  };

export function formatDateToDDMMYYYY(dateString: any) {
  const dateObject: any = new Date(dateString);

  if (isNaN(dateObject)) {
    return "Invalid Date";
  }

  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const year = dateObject.getFullYear();

  return `${day}.${month}.${year}`;
}

export function convertTimestamp(seconds: number, nanoseconds: number): string {
  const milliseconds = seconds * 1000 + nanoseconds / 1e6;

  const date = new Date(milliseconds);

  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };
  return date.toLocaleDateString("no-NO", options);
}

export function formatTimestamp(timestamp: any) {
  const date = new Date(timestamp?.seconds * 1000);

  const day = date.getDate();
  const month = date.toLocaleString("no-NO", { month: "long" });
  const year = date.getFullYear();

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}. ${month} ${year} | ${hours}:${minutes}`;
}

export function convertToFullDateString(timestamp: any) {
  if (!timestamp?.seconds) return "";

  const date = new Date(timestamp?.seconds * 1000);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
export function formatDateOnly(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export const formatDate = (dateStr: string) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day.padStart(2, "0")}.${month.padStart(2, "0")}.${year}`;
};

export function formatSpaceSeparatedToNOK(value: number | string) {
  const number =
    typeof value === "string"
      ? Number(value.replace(/\s/g, "").replace(/kr/i, ""))
      : value;

  if (isNaN(Number(number))) return value;

  const formatted = new Intl.NumberFormat("no-NO", {
    style: "decimal",
    useGrouping: true,
    minimumFractionDigits: 0,
  }).format(number);

  return `kr ${formatted}`;
}

export function convertFullStringTo24Hour(datetimeStr: any) {
  const [datePart, timePart] =
    datetimeStr && datetimeStr?.split("|").map((part: any) => part.trim());

  const [time, modifier] = timePart.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  } else if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  const hoursStr = hours.toString().padStart(2, "0");
  const minutesStr = minutes.toString().padStart(2, "0");
  const time24 = `${hoursStr}:${minutesStr}`;

  return `${datePart} | ${time24}`;
}
export function formatNorwegianPhone(phone: string): string {
  if (!phone) return "";

  let formatted = phone.startsWith("47") ? phone.slice(2) : phone;

  return `+47 ${formatted.replace(/(\d{2})(?=\d)/g, "$1 ").trim()}`;
}
export function formatNorwegianPhone2(phone: string): string {
  if (!phone) return "";

  let formatted = phone.startsWith("47") ? phone.slice(2) : phone;

  return `${formatted.replace(/(\d{2})(?=\d)/g, "$1 ").trim()}`;
}
